import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiPath } from 'constants/api';
import { INTERNAL_SERVER_ERROR } from 'constants/common';

import type { ApiClient } from '@travel/api-client';
import { noticeError } from '@travel/tracker';
type UpdateAnonymityParams = {
  reviewId: string;
  anonymous: boolean;
};

const updateReviewAnonymityAPI = (http: ApiClient, reviewId: string, anonymous: boolean) => {
  const url = `${apiPath.reviewAnonymity.pathname(reviewId)}?anonymous=${anonymous}`;

  return http.put(url, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateReviewAnonymity = createAsyncThunk<
  void,
  UpdateAnonymityParams,
  { extra: { apiClient: ApiClient } }
>(
  'review/updateAnonymity',
  async ({ reviewId, anonymous }, { extra: { apiClient }, rejectWithValue }) => {
    try {
      await updateReviewAnonymityAPI(apiClient, reviewId, anonymous);
    } catch (error: any) {
      noticeError('Failed to update anonymity', error);

      return rejectWithValue({
        message: error?.message || 'Failed to update anonymity',
        code: error?.code || INTERNAL_SERVER_ERROR,
      });
    }
  },
);
